import React, { useLayoutEffect, useRef } from 'react';
import { Button, Dropdown, Grid, Layout, Row, Col, theme, type MenuProps, Select } from 'antd';
import { DownOutlined, GlobalOutlined, MenuOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { useTranslation } from 'react-i18next';

type Props = {
  renderModelSelector?: boolean;
  modelMenu?: MenuProps;
  modelLabel?: string;
  modelColor?: string;
  disabled?: boolean;
  height?: number;
  mobileHeight?: number;
  position?: 'sticky' | 'fixed';
  zIndex?: number;
  onToggleDrawer?: () => void;
  onHeightChange?: (h: number) => void;
};

const AppHeader: React.FC<Props> = ({
  renderModelSelector = false,
  modelMenu,
  modelLabel = 'Selecciona modelo',
  modelColor = '#57d66a',
  disabled = false,
  height = 64,
  mobileHeight = 52,
  position = 'sticky',
  zIndex = 1000,
  onToggleDrawer,
  onHeightChange,
}) => {
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const H = isMobile ? mobileHeight : height;
  const ref = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const notify = () => onHeightChange?.(Math.round(el.getBoundingClientRect().height));
    notify();
    const ro = new ResizeObserver(notify);
    ro.observe(el);
    window.addEventListener('resize', notify);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', notify);
    };
  }, [onHeightChange]);

  const effectivePosition = position;


  const {t, i18n} = useTranslation()

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  const isDarkMode = useSelector((state: RootState) => state.theme.isDarkMode);
  
  

  


  return (
    <Layout.Header
      ref={ref as any}
      style={{
        position: isMobile ? 'fixed' : 'sticky',
        top: 0,
        left: 0,
        right: 0,
        zIndex,
        background: token.colorBgBase,
        borderBottom: isMobile ? `1px solid ${token.colorBorder}` : `1px solid ${isDarkMode ? 'black' : 'white'}`,
        padding: '0 16px',
        height: `calc(${H}px + env(safe-area-inset-top))`,
        paddingTop: 'env(safe-area-inset-top)',
        lineHeight: `${H}px`,
        width: '100%',
      }}
    >
      <Row justify="start" align="middle" style={{ height: '100%' }}>
        <Col>
          {isMobile && (
            <Button
              type="text"
              icon={<MenuOutlined />}
              style={{ fontSize: 20, padding: '4px 8px' }}
              onClick={onToggleDrawer || (() => window.dispatchEvent(new CustomEvent('toggleDrawer')))}
            />
          )}
        </Col>

        {renderModelSelector && (
          <Col>
            <Dropdown menu={modelMenu} trigger={['click']}>
              <Button style={{ border: 'none', boxShadow: 'none', fontWeight: 500 }} disabled={disabled}>
                <div
                  style={{
                    height: 8,
                    width: 8,
                    borderRadius: 20,
                    backgroundColor: modelColor,
                    marginRight: 8,
                    display: 'inline-block',
                  }}
                />
                {modelLabel} <DownOutlined />
              </Button>
            </Dropdown>
            
          </Col>
          
        )}

        <Col flex="auto" style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Select
            value={i18n.language}
            onChange={changeLanguage}

            suffixIcon={<GlobalOutlined />}
            options={[
              { value: 'en', label: t('settings.english') },
              { value: 'es', label: t('settings.spanish') },
            ]}
          />
        </Col>




      </Row>
    </Layout.Header>
  );
};

export default AppHeader;
